import React, { useState, useEffect, useRef } from "react";
import { Input, Button, Avatar, List, Space, Empty } from "antd";
import { SendOutlined, UserOutlined, CloudUploadOutlined, LinkOutlined } from "@ant-design/icons";
import "./ChatWindow.css";
import FileUpload from "../../../Chats/FileUpload/FileUpload";
import { isAuthenticated } from "../../../Auth/auth";
import { renderFile } from "../../../Chats/renderFile";
import { checkSpecificPermission } from "../../../../utils/checkPermissions";
import { Attachments, Sender, Bubble } from "@ant-design/x";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const MilestoneUpdates = ({ milestone, messages, onSendMessage }) => {
  const { t } = useTranslation("dashboard");
  const [input, setInput] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const attachmentsRef = useRef(null);
  const senderRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const sendMessage = () => {
    if (input === "") return;
    onSendMessage(input, uploadedFile);
    setInput("");
    setUploadedFile(null);
  };

  const senderHeader = (
    <Sender.Header
      title={t("Attachments")}
      styles={{
        content: {
          padding: 0
        }
      }}
      open={open}
      onOpenChange={setOpen}
      forceRender
    >
      <Attachments
        ref={attachmentsRef}
        beforeUpload={() => false}
        items={items}
        onChange={({ fileList }) => setItems(fileList)}
        placeholder={type =>
          type === "drop"
            ? {
                title: t("Drop file here")
              }
            : {
                icon: <CloudUploadOutlined />,
                title: t("Upload files"),
                description: t("Click or drag files to this area to upload")
              }
        }
        getDropContainer={() => {
          var _a;
          return (_a = senderRef.current) === null || _a === void 0 ? void 0 : _a.nativeElement;
        }}
      />
    </Sender.Header>
  );

  return (
    <>
      <div className="project-chat-window">
        <div className="project-chat-window__messages">
          {messages?.length === 0 ? (
            <Empty />
          ) : (
            <List
              itemLayout="horizontal"
              dataSource={messages}
              renderItem={message => {
                let user = message?.serviceProvider || message?.client || message?.employee;
                return (
                  <Bubble
                    // placement={`${message?.sender === sender?._id ? "start" : "end"}`}
                    content={message?.message}
                    header={
                      <Space>
                        <div>{user?.firstName + " " + user?.lastName} </div>
                      </Space>
                    }
                    avatar={{
                      icon: <UserOutlined />
                      // className: message?.sender === sender?._id ? 'barAvatar' : 'fooAvatar'
                    }}
                  />
                );
              }}
            />
          )}
        </div>

        {uploadedFile && (
          <div className="project-chat-window__preview">{renderFile(uploadedFile)}</div>
        )}
      </div>
      {checkSpecificPermission(isAuthenticated()?.roleId?.permissions, "Chats", "Create") && (
        <Sender
          ref={senderRef}
          className="project-chat-sender"
          header={senderHeader}
          autoSize={{ minRows: 2, maxRows: 6 }}
          prefix={
            <Button
              type="text"
              icon={<LinkOutlined />}
              aria-label={t("Attachments")}
              onClick={() => {
                setOpen(!open);
              }}
            />
          }
          value={input}
          onChange={setInput}
          onPasteFile={(_, files) => {
            var _a;
            for (const file of files) {
              (_a = attachmentsRef.current) === null || _a === void 0 ? void 0 : _a.upload(file);
            }
            setOpen(true);
            setUploadedFile(files);
          }}
          onSubmit={msg => {
            sendMessage();
          }}
        />
      )}
    </>
  );
};

export default MilestoneUpdates;
